import { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export interface TopCalloutProps {
  children: React.ReactNode;
  className?: string;
  icon?: IconDefinition;
  title?: string;
}

export const TopCallout: FC<TopCalloutProps> = ({ 
  children, 
  className = '', 
  icon,
  title = "Welcome! Let's Find the Perfect Match"
}) => {
  return (
    <div
      className={`bg-white p-6 rounded-[16px] shadow-lg mb-3 text-center ${className}`}
    >
      {icon && (
        <div className="flex justify-center mb-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-secondary border border-gray-200 shadow-sm">
            <FontAwesomeIcon icon={icon} className="h-5 w-5 text-primary" />
          </div>
        </div>
      )}

      <div className="space-y-2">
        <h2 className="text-2xl font-bold text-primary leading-tight">
          {title}
        </h2>

        <p className="text-sm text-gray-700 leading-relaxed max-w-2xl mx-auto">
          {children}
        </p>
      </div>
    </div>
  );
}; 